import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

import { Logo } from 'src/components/logo';

// ----------------------------------------------------------------------

const FooterRoot = styled('footer')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.vars.palette.background.paper,
}));

export function FooterSimple({ sx, ...other }) {
  const { t } = useTranslate();

  return (
    <FooterRoot
      sx={[{ py: 5, textAlign: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <Container>
        <Logo />
        <Box
          sx={{
            mt: 1,
            typography: 'caption',
            gap: { xs: 1, md: 0.5 },
            display: { xs: 'grid', md: 'flex' },
          }}
        >
          <div>
            © {new Date().getFullYear()} {CONFIG.appInvoice.name} v{CONFIG.appVersion}.
          </div>
          <div>{t('All rights reserved')}</div>
        </Box>
      </Container>
    </FooterRoot>
  );
}
